export const inputGroupStyle = { display: 'flex', flexDirection: 'row', gap: '16px', marginBottom: '16px', alignItems: 'flex-start' };
export const columnContainerStyle = { display: 'flex', flexDirection: 'row', gap: '24px', width: '100%', minWidth: 0 };
export const columnStyle = { display: 'flex', flexDirection: 'column', flex: 1, minWidth: 0 };
